/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.graph.listitem'

export { $nsid }

/** Record representing an account's inclusion on a specific list. The AppView will ignore duplicate listitem records. */
type Main = {
  $type: 'app.bsky.graph.listitem'

  /**
   * The account which is included on the list.
   */
  subject: l.DidString

  /**
   * Reference (AT-URI) to the list record (app.bsky.graph.list).
   */
  list: l.AtUriString
  createdAt: l.DatetimeString
}

export type { Main }

/** Record representing an account's inclusion on a specific list. The AppView will ignore duplicate listitem records. */
const main = l.record<'tid', Main>(
  'tid',
  $nsid,
  l.object({
    subject: l.string({ format: 'did' }),
    list: l.string({ format: 'at-uri' }),
    createdAt: l.string({ format: 'datetime' }),
  }),
)

export { main }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main),
  $build = /*#__PURE__*/ main.build.bind(main),
  $type = /*#__PURE__*/ main.$type
export const $assert = /*#__PURE__*/ main.assert.bind(main),
  $check = /*#__PURE__*/ main.check.bind(main),
  $cast = /*#__PURE__*/ main.cast.bind(main),
  $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main),
  $matches = /*#__PURE__*/ main.matches.bind(main),
  $parse = /*#__PURE__*/ main.parse.bind(main),
  $safeParse = /*#__PURE__*/ main.safeParse.bind(main),
  $validate = /*#__PURE__*/ main.validate.bind(main),
  $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
